import styles from './ApplicationsTableNoSearchResult.module.scss';

interface ApplicationsTableNoSearchResultProps {
  searchValue: string;
}

const ApplicationsTableNoSearchResult = ({ searchValue }: ApplicationsTableNoSearchResultProps) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.headerContainer}>
        <div>Sorry, we couldn't find any matches for: {searchValue}</div>
      </div>
      <div className={styles.advice}>
        <div className={styles.adviceMarker} />
        Please make sure that the spelling is correct
      </div>
      <div className={styles.advice}>
        <div className={styles.adviceMarker} />
        Use fewer keywords in your search
      </div>
    </div>
  );
};

export default ApplicationsTableNoSearchResult;
